<template>
  <div>
    <c-search-form :fields="fields"
                   :form-name="formName"
                   :reload="timeReload"
                   :rows-per-page-items="[10,20,50]"
                   @createNew="openCreateDialog"
                   @editItem="openCreateDialog"
                   accept-delete
                   create-url="/emailConfig/save"
                   custom-create-new
                   custom-edit-item
                   delete-url="/emailConfig/delete"
                   formType="intable"
                   key-property="emailConfigId"
                   search-url="/emailConfig/search">
    </c-search-form>
    <email-config-create :cDialog="visibleCreateDialog"
                  :propsItem="propsItemCreate"
                  @closeDialog="closeCreateDialog"/>
  </div>


</template>

<script>
  import CSearchForm from "../../../components/form/ManageForm";
  import EmailConfigCreate from "./EmailConfigCreate";
  import axios from "axios";

  export default {
    name: 'email-config-list',
    components: {
      EmailConfigCreate, CSearchForm
    },
    data: () => {
      return {
        formName: "lang.emailConfig.emailConfigForm",
        createFormName: "lang.emailConfig.createEmailConfig",
        propsItemCreate: null,
        visibleCreateDialog: false,
        cDialog: false,
        timeReload: 0,
        timeReloadWaiting: 0,
        groups: [],
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center"
          },
          {
            value: 'email',
            text: 'lang.emailConfig.email',
            width: "30%",
            sortable: false,
            headerStyle: "text-align:left"
          },
          {
            type: "select",
            name: "groupId",
            itemText: "groupName",
            itemValue: "groupId",
            items: [],
            text: 'lang.groups.groupName',
            width: "15%",
            sortable: false,
            headerStyle: "text-align:left"
          },
          {
            value: 'action',
            text: 'lang.common.actions',
            width: "10%",
            sortable: false,
            compound: true,
            headerStyle: "text-align:center"
          }
        ]
      }
    },
    methods: {

      openCreateDialog: function (item = null) {
        this.propsItemCreate = item;
        this.visibleCreateDialog = true;
      },

      closeCreateDialog: function () {
        this.propsItemCreate = null;
        this.visibleCreateDialog = false;
        this.timeReload = Math.floor(Math.random() * 100);
      },
    },
    created() {
      axios.post(process.env.VUE_APP_API_URL + "/groups/search?page=-1&pageSize=-1", {}).then(
          data => {
            this.fields.filter(e => e.name == "groupId")[0].items = data.items;
          }
      )
    }
  }
</script>
